
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['add_fees_payment']==1">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-md-4">
          <div class="card shadow-sm">
            <div class="card-body">
              <form @submit.prevent="AddtoCart">
              <span v-if="this.feescarts.length<=0">
                <label>Student : <small class="text-primary">{{ student.student_id }}</small></label>
                <multiselect v-model="student" :options="students" placeholder="Select Student" :custom-label="customLabel"> 
                </multiselect>
                <label>Term</label>
                <multiselect v-model="schoolterm" label="name" :options="schoolterms"></multiselect>
                <label>Year</label>
                <multiselect v-model="year"  :options="years"></multiselect>
                </span>
                  <div class="form-group mb-2">
                  <label>Fees</label>
                    <multiselect v-model="fees" label="name" @input="FilterFees()" :options="feescategories"></multiselect>
                  </div>
                  <div class="form-group mb-2">
                    <label>Fees Amount</label>
                    <input v-model="amount" readonly style="background: none;" class="form-control" />
                  </div>
                  <div class="form-group mb-3">
                      <label>Amount Paid</label>
                      <input v-model="amountpaid" type="number" required class="form-control" />
                    </div>
                  <div class="form-group">
                <button class="btn btn-primary w-100" :disabled="loader"> <b-spinner v-if="loader" small class="mr-1" label="Small Spinner"/><i v-else class="fas fa-check-circle"></i> Submit</button>
                </div>
                </form>
            </div>
          </div>
          </div>
          <div class="col-md-8">    
            <div class="card shadow-sm">
              <span v-if="this.feescarts.length<=0">
                <div class="text-center p-5">
                <span class="mdi mdi-cash text-success display-2"></span><br>
                <span class="h4">No Item Selected</span>
              </div>
              </span>
              <span v-else>
                <div class="row p-3">
                  <div class="col-md-7">
                  <div class="h4">{{ feescarts[0].student.first_name }} {{ feescarts[0].student.last_name }} - {{ feescarts[0].schoolterm.name }} - {{ feescarts[0].year }}</div>
                  <div class="table-responsive">
                    <b-table
                      :items="Items"
                      :fields="Fields"
                      responsive="sm"
                      :busy="IsBusy"
                    >
                    <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>
                    <template #cell(fees)="data">
                      {{ data.item.fees.name }}
                    </template>
                    <template #cell(actions)="data">
                      <b-button @click="remove(data.item.id,data.item.fees.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                    </template>
                    </b-table>
                  </div>
                </div>
                  <div class="col-md-5">
                    <div class="form-group mb-2">
                      <b>Total</b>
                      <input v-model="cart_total" type="number" readonly class="form-control" />
                    </div>
                    <div class="form-group mb-2">
                      <b>Payment Option</b>                        
                      <multiselect v-model="payoption" label="name" :options="paymentoptions"></multiselect>
                    </div>
                    <div class="form-group">
                      <b>Pay Date</b>
                      <input v-model="paydate" type="date" required class="form-control" />
                    </div>
                    <div class="d-flex justify-content-between mt-3">
                      <div><b-button class="btn btn-sm" @click="SubmitPrint" variant="success" :disabled="loader"> <b-spinner v-if="loader" small class="mr-1" label="Small Spinner"/><i v-else class="mdi mdi-printer"></i> SUBMIT & PRINT</b-button></div>
                      <div><b-button class="btn btn-sm" @click="SubmitExit" variant="primary" :disabled="loader"> <b-spinner v-if="loader" small class="mr-1" label="Small Spinner"/><i v-else class="mdi mdi-check-circle"></i> SUBMIT & EXIT</b-button></div>
                    </div>
                   </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="delete-cart" centered title="Delete From Cart" title-class="font-18" hide-footer>
      <form @submit.prevent="removeFromCart">
          <input v-model="id" type="hidden">
            Are you sure you want to remove the Expense : <b>{{ fees }}</b> ?
          <div class="form-group d-flex justify-content-end">
              <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-cart')" >Close</b-button>
              <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
          </div>
      </form>
    </b-modal> 
  </div>  
  <div v-else>
    <div class="row justify-content-center">
      <div class="col-md-8 col-xl-6">
        <div>
          <center><span class="text-primary h4">You have no permission to view the Dashboard.</span></center>
          <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
        </div>
      </div>
    </div>
  </div> 
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";

import {
  feescartComputed, feescartMethods,
  feescategoryComputed,
  feescategoryMethods,
  paymentoptionComputed,
  paymentoptionMethods,
  schooltermComputed,
  schooltermMethods,
  studentComputed,
  studentMethods
} from "@/state/helpers";


export default {
  page: {
    title: "New Fees Payment",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,PageHeader,Multiselect,
  },
  data() {
    return {
      title: "New Fees Payment",
      items: [{text: "Dashboard",href: "/"},{text: "New Fees Payment",active: true}],
      isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'fees', label: 'Fees', visible: true },
            { key: 'amountpaid', label: 'Amount', visible: true },
            { key: 'actions', label: 'Remove', visible: true },
          ],userData: JSON.parse(localStorage.getItem("user")),
      id:'',
      schoolterm:'', year:new Date().getFullYear(),
      fees:'',
      student:'',student_id:'',
      amount: "",
      paydate:new Date().toLocaleDateString('fr-CA'),
      payoption:'',
      amountpaid:'0',
      loader:false,
    };
  },
  methods: {
    ...feescategoryMethods,
    ...schooltermMethods,
    ...studentMethods,
    ...feescartMethods,
    ...paymentoptionMethods,
    customLabel(student) {
   return `${student.student.first_name} ${student.student.last_name} ${student.class.name } ${student.stream.name }`;
},
    async FilterFees(){
      if (this.feescarts.length<=0) {
          // this.student = this.student;
          this.student = this.student.student.student_id
          this.schoolterm = this.schoolterm.id;
          this.year = this.year;
        } else {
          this.student = this.selectedStudent;
          this.schoolterm = this.selectedTerm;
          this.year = this.selectedYear;
        }
      let url = `/findfeesamount/${this.student},${this.fees.id},${this.schoolterm},${this.year}`;
      await axios.get(url).then((response) => {
        this.amount = response.data.amount;
      });
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
      remove(id,fees){
        this.id=id;
        this.fees=fees;
        this.$bvModal.show('delete-cart')
      },
    async AddtoCart() { 
        this.loader=true;
        let formData = new FormData();
        if (this.feescarts.length<=0) {
          formData.append("student", this.student);
          formData.append("term", this.schoolterm);
          formData.append("year", this.year);
        } else {
          formData.append("student", this.selectedStudent);
          formData.append("term", this.selectedTerm);
          formData.append("year", this.selectedYear);
        }
        formData.append("fees", this.fees.id);
        formData.append("amount", this.amount);
        formData.append("amountpaid", this.amountpaid);
        let url = "/addfeescart";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.payoption = this.paymentoptions.find(option => option.set_default == 1);
            this.fetchFeesCart();
            this.student="";
            this.schoolterm="";
            this.fees="";
            this.amount="";
            this.amountpaid="";
            this.loader=false;
          }
        });
      },
      async removeFromCart() { 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/deletefeescart";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchFeesCart();
          this.$bvModal.hide('delete-cart');
        }
      });
      },
      async SubmitExit(){
        this.loader=true;
        let obj = {cart:this.Cart, student:this.selectedStudent, term:this.selectedTerm, year:this.selectedYear, total:this.cart_total, payoption:this.payoption.id,paydate:this.paydate }
        let url = "/savefeescart";
        await axios.post(url, obj).then((response) => {
          if (response.status == 200) {
            this.fetchFeesCart();
            this.$swal({ title:'Success', text:response.data.message, icon:'success'});
            this.loader=false;
          }
        });
      },
      async SubmitPrint(){
        this.loader=true;
        let obj = {cart:this.Cart, student:this.selectedStudent, term:this.selectedTerm, year:this.selectedYear, total:this.cart_total, payoption:this.payoption.id,paydate:this.paydate }
        let url = "/savefeescart";
        await axios.post(url, obj).then((response) => {
          if (response.status == 200) {
            this.$router.push({ path: '/printreciept',  query: { id: response.data.receipt_id } })
            // this.$swal({ title:'Success', text:response.data.message, icon:'success'});
            this.loader=false;
          }
        });
      }
    },
    computed: {
      ...feescategoryComputed,
      ...schooltermComputed,
      ...studentComputed,
      ...feescartComputed,
      ...paymentoptionComputed,
      cart_total(){ var total = 0; this.feescarts.forEach((item)=>{ var item_total = Number(item.amountpaid); total = Number(total)+Number(item_total);}); return total },
      List() { return this.feescarts.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.feescarts.map((d) => ({...d }))},
      Cart() { return this.feescarts.map((d) => ({id:d.id,fees:d.fees.id,amountpaid:d.amountpaid }))},
      IsBusy() { let a=false; if (this.feescarts.length>0) { a=false;} else { a=true;} return a },
      selectedStudent() { let a=false; if (this.feescarts.length>0) { a =  this.feescarts[0].student.student_id;} else { a='';} return a },
      selectedTerm() { let a=false; if (this.feescarts.length>0) { a =  this.feescarts[0].schoolterm.id;} else { a='';} return a },
      selectedYear() { let a=false; if (this.feescarts.length>0) { a =  this.feescarts[0].year;} else { a='';} return a },
      years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {  yearArray.push(year);  }
      return yearArray;
    },
    },
    mounted() {
      this.fetchFeesCategories();
      this.fetchStudents();
      this.fetchSchoolTerms();
      this.fetchFeesCart();
      this.fetchPaymentoptions();
      this.isBusy=false;
      this.payoption = this.paymentoptions.find(option => option.set_default == 1);
      // this.schoolterm = this.schoolterms.find(option => option.active == 1);
    },
  };
</script>
